import { render, staticRenderFns } from "./OutreachAuthorDetailView.vue?vue&type=template&id=e8c444f4&"
import script from "./OutreachAuthorDetailView.vue?vue&type=script&lang=js&"
export * from "./OutreachAuthorDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports